<template>
  <div class="campo-senha-composto">
    
    <div class="row">
        
        <div class="col-md-6 mb-3">
    
            <CampoDeEntrada
                :autocomplete="disableAutocomplete?'new-password':'on'"
                label="Senha"
                type="password"
                icon="ri-lock-line"
                placeHolder="Mín. 8, com maiúscula, número e símbolo"
                :modelValue="senha"
                @update:modelValue="senhaAtualiza"
                :required="!opcional"
            />

            <div class="checklist-container w-100 mt-1 text-start">

                <div v-if="senha.length > 0" class="indicador-forca-barra d-flex align-items-center mb-2">
                    <div :class="['forca-barra', classeForcaSenha]" :style="{ width: barraForca }"></div>
                    <small :class="['forca-texto ms-2', classeForcaSenha]">
                        Força: {{ textoForcaSenha }}
                    </small>
                </div>

                <small class="d-block text-muted mb-1">A senha precisa ter:</small>
                <ul class="list-unstyled mb-0 checklist-list">
                    <li v-for="regra in regras" :key="regra.chave" :class="regra.ok ? 'text-success' : 'text-danger'">
                        <i :class="regra.ok ? 'ri-check-fill' : 'ri-close-fill'"></i> {{ regra.texto }}
                    </li>
                </ul>
            </div>
            </div>

        <div class="col-md-6 mb-3">
            <CampoDeEntrada
                :autocomplete="disableAutocomplete?'new-password':'on'"
                label="Confirmação de senha"
                type="password"
                icon="ri-check-line"
                placeHolder="Confirme sua senha"
                :modelValue="confirmaSenha"
                @update:modelValue="atualizaConfirmacao"
                :required="!opcional && senha.length > 0"
            />
        </div>
    </div>
    
    <p v-if="!senhaIdentica && confirmaSenha.length > 0" class="alert alert-danger p-2 mt-2 mb-0">
      As senhas não coincidem!
    </p>

    <p v-if="!senhaForte && senha.length > 0 && confirmaSenha.length > 0 && senhaIdentica" class="alert alert-warning p-2 mt-2 mb-0">
        A senha ainda não cumpre todos os itens da lista. Só senhas "muito forte" são aceitas.
    </p>

  </div>
</template>

<script>

import CampoDeEntrada from './InputField.vue'
import { regrasDaSenha, senhaAtendeRegra } from '@/utils/validacaoUsuario'

export default {

  emits: ['update:modelValue', 'eValido'], 
  components: {
    CampoDeEntrada 
  },
  props: {
    disableAutocomplete: { type: Boolean, default: false },
    opcional: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      senha: '',
      confirmaSenha: '',
      nivelForca: 0
    }
  },
  computed: {
    senhaIdentica () {
      return this.senha === this.confirmaSenha
    },

    regras () {
      return regrasDaSenha(this.senha)
    },

    // F-18: a regra do server (`@IsStrongPassword`) exige os 5 itens — só
    // "muito forte" passa. Antes a tela aceitava "média" e a API recusava.
    senhaForte () {
      return senhaAtendeRegra(this.senha)
    },

    textoForcaSenha () {
      switch (this.nivelForca) {
        case 0: return 'Nenhuma'
        case 1: return 'Fraca'
        case 2: return 'Média'
        case 3: return 'Forte'
        case 4: return 'Muito forte'
        default: return 'Nenhuma'
      }
    },

    classeForcaSenha () {
      switch (this.nivelForca) {
        case 1: return 'forca-fraca'
        case 2: return 'forca-media'
        case 3: return 'forca-forte'
        case 4: return 'forca-muito-forte'
        default: return 'forca-nenhuma'
      }
    },

    barraForca () {
        return (this.nivelForca * 25) + '%'
    },

    senhaValida () {
        if (this.opcional && this.senha.length === 0) {
            return true;
        }

        const pPreenchida = this.senha.length > 0
        const cPreenchida = this.confirmaSenha.length > 0

        return pPreenchida && cPreenchida && this.senhaIdentica && this.senhaForte
    }
  },
  watch: {
    senhaValida (eValido) {
      this.$emit('eValido', eValido)
      if (eValido) {
        this.$emit('update:modelValue', this.senha)
      } else {
        this.$emit('update:modelValue', null)
      }
    }
  },
  methods: {
    verificarForca (senha) {
      let pontuacao = 0
      if (!senha) return 0

      if (senha.length >= 8) pontuacao++
      if (senha.match(/[a-z]/) && senha.match(/[A-Z]/)) pontuacao++
      if (senha.match(/\d/)) pontuacao++
      // Nível 4 ("muito forte") só com a regra inteira — o mesmo símbolo do server.
      if (senhaAtendeRegra(senha)) pontuacao = 4
      else pontuacao = Math.min(pontuacao, 3)

      return pontuacao
    },

    senhaAtualiza (valor) {
      this.senha = valor
      this.nivelForca = this.verificarForca(valor)
    },

    atualizaConfirmacao (valor) {
      this.confirmaSenha = valor
    }
  }
}
</script>

<style scoped>

.checklist-container {
    padding-left: 12px;
}

.indicador-forca-barra {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
}

.forca-barra {
    height: 4px;
    border-radius: 2px;
    width: 100px; 
    transition: width 0.3s ease-in-out, background-color 0.3s ease-in-out;
}

.forca-barra.forca-fraca { background-color: #dc3545; } 
.forca-barra.forca-media { background-color: #ffc107; } 
.forca-barra.forca-forte { background-color: #198754; } 
.forca-barra.forca-muito-forte { background-color: #0d6efd; } 

.forca-texto.forca-fraca { color: #dc3545; }
.forca-texto.forca-media { color: #ffc107; }
.forca-texto.forca-forte { color: #198754; }
.forca-texto.forca-muito-forte { color: #0d6efd; }

.checklist-list {
    padding-left: 0;
}

.checklist-list li {
    line-height: 1.5;
    font-size: 0.85em;
    list-style: none;
}

.checklist-list i {
    width: 15px;
    margin-right: 5px;
}

.checklist-opcional {
    font-style: italic;
}

.error-message {
    color: #ff4d4f;
    font-size: 0.85em;
    margin-top: -10px;
    margin-bottom: 15px;
}
</style>